module.exports = __webpack_public_path__ + "static/two_phones-6b5217d607b4ad34794ea230c01c1d97.png";